import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {FiltersMobileButtonBox} from "../../../filters/filters-games-list-mobile/boxes/menu-button/filters-mobile-button.box";
import {Link} from "../../../raw-components/link/link";
import React from "react";
import classNames from "classnames";
import {ACTIVE} from "../../../../themes/css-global-classes";
import {observer} from "mobx-react";

export const FiltersMobileButtonComponent = observer(class FiltersMobileButtonComponent extends OrbitComponent<{}> {

  private _openPopup = () => {
    this.services.gamesFilter.showFiltersEditor();
  };

  render(){
    if(!this.services.gamesFilter.isFilteringAvailable) {
      return null;
    }

    if(this.services.arenas.shouldHideFiltersButtonMobile()) {
      return null;
    }

    const FilterIcon = this.services.theme.currentTheme.icons.filterIcon;

    return (
    <Link box={FiltersMobileButtonBox} className={classNames('cy-open-filters-button', {[ACTIVE] : this.services.gamesFilter.isFilterOn})} onClick={this._openPopup}>
      <FilterIcon size={1.6} className={'cy-filter-icon'} />
    </Link>
    )
  }
});